import Toggle from 'atoms/toggle';

import RebookSlotSelector from './RebookSlotSelector';

export default function RebookAppointment({
  isRebook,
  setIsRebook,
  selectedTimeSlot,
  setSelectedTimeSlot,
}) {
  return (
    <div className="mb-12 p-24 border-light-purple radius-24">
      <div className="flex-row justify-between">
        <h4>Rebook appointment</h4>
        <Toggle setState={setIsRebook} enabled={isRebook} variant="orange" />
      </div>
      {isRebook && (
        <div className="mt-12">
          <RebookSlotSelector
            selectedTimeSlot={selectedTimeSlot}
            setSelectedTimeSlot={setSelectedTimeSlot}
          />
        </div>
      )}
    </div>
  );
}
